<template>
  <div class="mt-2">
    <b-modal
      id="activity-modal"
      hide-footer
      hide-header
      centered
      size="lg"
      content-class="p-2 text-center bg-light styled-modal centered pr-4 pl-4"
    >
      <button
        class="close-button"
        :title="$t('lang.activities.close')"
        @click="closeModal()"
      >
        ✖
      </button>
      <ActivityDetails
        :activity="selectedActivity"
        @closeModal="closeModal"
      />
    </b-modal>
    <div>
      <h5 class="d-inline">
        {{ $t('lang.activities.title') }}
      </h5>

      <div class="poweredBy">
        <span class="small">Powered by
          <img
            src="../../assets/img/civitatis-logo.png"
            height="15"
          >
        </span>
      </div>
    </div>

    <div>
      <VueperSlides
        class="no-shadow activities mt-3 mb-3"
        :visible-slides="2"
        :slide-multiple="2"
        :breakpoints="breakpoints"
        :touchable="true"
        :dragging-distance="20"
        :arrows="true"
        :bullets="false"
        fixed-height="350px"
      >
        <VueperSlide>
          <template #content>
            <div
              class="activities-box transfer"
              @click="openTransfer()"
            >
              <div class="strip grid no-shadow">
                <figure>
                  <img
                    class="img-cover"
                    src="../../assets/img/transfers/transfer.jpg"
                    alt="transfer"
                    title="transfer"
                  >
                </figure>
                <div class="wrapper">
                  <h5>
                    {{ $t('lang.transfer.transfers_carousel_title') }}
                  </h5>
                  <p v-html="$t('lang.transfer.discount_transfer_card')" />
                  <button
                    class="btn btn_1 activity-btn"
                    @click="openTransfer()"
                  >
                    {{ $t('lang.bookings.transfer_button') }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </vueperslide>
        <VueperSlide
          v-for="(activity, index) in activities"
          v-if="activities"
          :key="'activities_'+index"
        >
          <template #content>
            <div class="activities-box">
              <div class="strip grid no-shadow">
                <figure>
                  <img
                    class="img-cover"
                    :src="activity.image"
                    :alt="activity.title"
                    :title="activity.title"
                  >
                </figure>
                <div class="wrapper">
                  <h6>{{ shortTitle(activity.title) }}</h6>

                  <div class="d-flex justify-content-between align-items-center">
                    <div class="reputation-div">
                      <ReputationIcons
                        :score="activity.score/2"
                        :reviews="activity.reviews"
                      />
                    </div>
                    <span class="loc_open schedule text-right">
                      {{ getDateToShow(activity['nextScheduleDateTime']) }}
                    </span>
                  </div>

                  <h5 class="m-0 price">
                    {{ $t('lang.activities.free') }}
                  </h5>

                  <button
                    class="btn btn_1 activity-btn"
                    @click="clickActivity(index)"
                  >
                    {{ $t('lang.activities.open_details') }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </vueperslide>
      </vueperslides>
    </div>
  </div>
</template>
<script>
import { VueperSlide, VueperSlides } from 'vueperslides';
import '@/assets/css/custom-vueper-slide.css';

import { API, errorResponse } from '@/api/api';
import { cities } from '@/data/cities';
import ActivityDetails from './ActivityDetails';
import ReputationIcons from './ReputationIcons';

const ActivitiesAPI = API.get('activities');
const ShippingAPI = API.get('shipping');

export default {
  name: 'FreeTourCarousel',
  components: {
    ReputationIcons,
    ActivityDetails,
    VueperSlides,
    VueperSlide,
  },
  props: {
    cityId: {
      type: Number,
      required: true,
    },
    bookingId: {
      type: Number,
      required: true,
    },
    transferUrl: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      breakpoints:
          {
            1200: {
              visibleSlides: 1,
              slideMultiple: 1,
              arrows: true,
              bullets: false,
              touchable: true,
              fixedHeight: '350px',
            },
          },
      activities: null,
      selectedActivity: null,
    };
  },
  async created() {
    try {
      const { data } = await ActivitiesAPI.getActivities({ city_id: this.cityId });
      if (data.length) {
        this.activities = data;
      }
    } catch (error) {
      this.errors = errorResponse(error);
    }

    const city = cities.find((data) => data.bd_city_id === this.cityId).id;
  },

  methods: {
    getDateToShow(schedule) {
      const lang = window.navigator.language;
      const today = new Date().toISOString().split('T')[0];
      const tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0];

      let scheduleDay = schedule.split(' ');

      if (today === scheduleDay[0]) {
        return `${this.$t('lang.search.dates.today')} ${scheduleDay[1].slice(0, -3)} h`;
      }
      if (tomorrow === scheduleDay[0]) {
        return `${this.$t('lang.search.dates.tomorrow')} ${scheduleDay[1].slice(0, -3)} h`;
      }
      // agrego los 00:00:00 porque sino cambia de día según el utc.
      scheduleDay = `${new Date(`${scheduleDay[0]} 00:00:00`).toLocaleString(lang, {
        day: '2-digit', month: '2-digit',
      })} ${scheduleDay[1].slice(0, -3)} h`;

      return scheduleDay;
    },

    shortTitle(title) {
      if (title.length > 60) {
        return `${title.substring(0, 60)}...`;
      }
      return title;
    },

    async clickActivity(index) {
      ShippingAPI.shippingServiceRequest({
        booking_id: this.bookingId,
        shipping_service_option: 'open-free-tour',
        address: this.activities[index].title,
      });
      try {
        const { data } = await ActivitiesAPI.getActivityDetails(this.activities[index].id);

        if (data) {
          this.selectedActivity = data;
          this.$bvModal.show('activity-modal');
        }
      } catch (error) {
        this.errors = errorResponse(error);
      }
    },
    openTransfer() {
      ShippingAPI.shippingServiceRequest({
        booking_id: this.bookingId,
        shipping_service_option: 'open-transfer-int',
      });
      this.$router.push(this.transferUrl);
    },

    closeModal() {
      this.$bvModal.hide('activity-modal');
    },
  },
};
</script>

<style scoped>
.activities-box{
  margin: 0 1rem;
}
.activities-box figure {
  text-align: center;
  height: 160px;
}

.wrapper{
  height: 170px;
}

.activity-btn{
  position: absolute;
  bottom: 15px;
  right: 25px;
}

.transfer .wrapper .activity-btn{
  position: initial;
  width: 100%;
}

.price{
  position: absolute;
  bottom: 20px;
}

.schedule{
  position: absolute;
  bottom: 65px;
  right: 25px;
}
.strip{
  box-shadow: none
}

.reputation-div{
  position: absolute;
  bottom: 62px;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  font-weight: normal;
  color: rgba(110, 107, 107, 0.6);
  background: transparent ;
  border: none;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  z-index: 10000;
}
.close-button:hover {
  color: #000000;
}
</style>
